import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/** A thin determinate bar: `value` of `max`, named for screen readers by `label`. */
@Component({
  selector: 'app-progress-bar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="h-2 overflow-hidden rounded-full bg-surface-secondary"
      role="progressbar"
      aria-valuemin="0"
      [attr.aria-valuemax]="max()"
      [attr.aria-valuenow]="value()"
      [attr.aria-label]="label()"
    >
      <div class="h-full rounded-full bg-accent-06" [style.width.%]="percent()"></div>
    </div>
  `,
})
export class ProgressBarComponent {
  public readonly value = input.required<number>();
  public readonly max = input.required<number>();
  public readonly label = input.required<string>();

  protected readonly percent = computed(() => Math.min(100, Math.max(0, (this.value() / this.max()) * 100)));
}
